
import {Component, Vue} from 'vue-property-decorator';
import {nil} from '@/common';

@Component
export default class CurrencyMixin extends Vue {
    public priceDisplay(price: number): string {
        return '$' + price.toFixed(2);
    }
    public calculateServicePrice(basePrice, hours= 1, guests= 1) {
        return basePrice * (guests) + ((hours - 1) * 150);
    }
    public calculateBookingPrice(booking) {
        const service = booking.purchasableModel;
        if (nil(service)) { throw Error('Cannot calculate price without bookable service'); }
        if(!nil(booking.groupKey)){
            return booking.groupPayment / booking.groupProCount
        }
        return this.calculateServicePrice(service.price, booking.duration, booking.guests);
    }
}
